import { GetTokenOptions, Messaging, getMessaging, getToken, onMessage } from 'firebase/messaging';

export const firebaseWrapper = {
  getMessaging: () => getMessaging(),
  getToken: (messaging: Messaging, options?: GetTokenOptions) => getToken(messaging, options),
  onMessage: (messaging: Messaging, callback: (payload: any) => void) => onMessage(messaging, callback)
};